import { createFeature, createReducer } from '@ngrx/store';

import { overviewTimelineReducers } from './overview-timeline.reducers';
import { overviewTimelineInitialState } from './overview-timeline.state';

export const overviewTimelineFeature = createFeature({
  name: 'jobV3OverviewTimeline',
  reducer: createReducer(overviewTimelineInitialState, ...overviewTimelineReducers),
});
